import { GetMarketOffersParams } from 'api/prosAPI'
import { ServiceTypes } from 'common/types/commonTypes'

import Actions from '../actions'

export type MarketFilterStateType = Omit<GetMarketOffersParams, 'typeOfRecruitment'> & {
  typeOfRecruitment: ServiceTypes
}

type FilterValues = Partial<MarketFilterStateType>

export function setMarketFilter(filter: FilterValues) {
  return {
    type: Actions.SET_MARKET_FILTER,
    payload: {
      filter: {
        page: 0,
        clearPagesCount: true,
        ...filter,
      },
    },
  }
}
